interface BusinessNameGeneratorUserPromptSummaryProps {
    userPrompt: string
}

export function BusinessNameGeneratorUserPromptSummary({
    userPrompt,
}: BusinessNameGeneratorUserPromptSummaryProps) {
    return (
        <div className="mb-6 rounded-lg border border-stone-200 bg-stone-50 p-4">
            <span className="block text-xs font-semibold uppercase tracking-wider text-gray-500">
                Your business
            </span>

            <p className="mt-1 text-sm leading-relaxed text-gray-800">
                {userPrompt}
            </p>
        </div>
    )
}
